import { ITradingAccount } from '@aqx-core/common/api/user-account';

import { IViewTradingAccountBalances } from './types';

export const extractBalanceFields = (account: Partial<ITradingAccount>): IViewTradingAccountBalances => {
  const fields: (keyof IViewTradingAccountBalances)[] = [
    'equity',
    'margin',
    'balance',
    'freeMargin',
    'profitLoss',
    'marginLevel',
    'marginCall',
    'marginStopout',
    'notional',
    'commission',
    'swaps',
    'availableWithdraw',
    'credit',
    'tradingState',
    'buyingPower',
    'pnlGross'
  ];
  return Object.fromEntries(fields.map((field) => [field, account[field]])) as IViewTradingAccountBalances;
};
